import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function getUserWidgetData(userId) {
  try {
    const res = await tryCache('getUserWidgetData' + '-' + userId, () =>
      apiClient.get(`/getWidgets/${userId ? userId : ''}`),
    );
    return res;
  } catch (error) {
    console.error('getWidgets failed.', error);
  }
}

export async function updateUserWidgetLayout(layout) {
  try {
    loginfo();
    return await apiClient.post('/updateUserWidgetLayout', {
      widgetLayout: JSON.stringify(layout),
    });
  } catch (error) {
    console.error('updateUserWidgetLayout failed.', error);
  }
}
